export default "__VITE_ASSET__517d31b4__"